<template>
    <div class="mb-2">
        <input type="button" @click="adicionarEstilo" class="btn btn-success" value="Criar">
    </div>
</template>
<script>

export default {

    data: function () {
        return {
            VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
            loading: false,
            Autoplay: {
                id_vsl: 174,
                autoplayer_text_color: "white",
                autoplayer_back_color: "red",
                autoplayer_top_text: "Seu video já começouu",
                autoplayer_button_text: "Clique para ouvir."
            },
            errorMessage: null,

        }
    },

    methods: {
        adicionarEstilo() {
            fetch(`${this.VUE_APP_HOST_API_BACKEND}/autoplayer`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: '{"id_vsl":"' + this.Autoplay.id_vsl +
                    '","autoplayer_text_color":"' + this.Autoplay.autoplayer_text_color +
                    '","autoplayer_back_color":"' + this.Autoplay.autoplayer_back_color +
                    '","autoplayer_top_text":"' + this.Autoplay.autoplayer_top_text +
                    '","autoplayer_button_text":"' + this.Autoplay.autoplayer_button_text +

                    '"}'
            })

                .then(response => {
                    this.$alert("adicionado com sucesso.")
                    return this.$router.push('');

                })
                .catch(err => console.error(err));
        },

    }
}


</script>
